<template>
  <section v-if="ShowBar" :class="{ closed: showSiderBar, limitWidth: limitWidth }" class="layout-sider-bar">
    <div v-if="!MyViewBar" class="layout-sider-bar-content">
      <div v-if="ShowTitle" class="layout-sider-bar-content-header">
        {{ Title }}
        <slot name="Title"/>
        <power :Action="Framework.Operating.Add" :Module="props.Module">
          <template #default="scopePower">
            <el-tooltip v-if="ShowCreateButton" :disabled="scopePower.hasPower" content="无新建权限" placement="top">
              <el-button :disabled="!scopePower.hasPower" class="icon-btn" @click="emit('CreateHandle')">
                <svg-icon :class="{ 'not-allow': !scopePower.hasPower }" icon-class="plus"/>
              </el-button>
            </el-tooltip>
          </template>
        </power>
      </div>
      <!--      <el-input v-if="IsTree" v-model="treeFilterText" :placeholder="$t('Operation.FilterKeyword')" clearable/>-->
      <slot name="TreeFilter"/>
      <div v-if="IsTree" ref="treeWrapRef" class="tree-v2-wrap">
        <!--TODO 这边要实现树-->
      </div>
      <el-scrollbar v-else>
        <el-menu :default-active="ViewCurrent" @select="SelectedChanged($event,undefined)">
          <el-menu-item v-for="(view, index) in Datas" :key="index" :index="(view as any).value.toString()">
            <span
                :class="{    disabled: (view as any).value && (view as any).value.length === 32 && (view as any).Estate !== Framework.Estate.Normal   }"
                class="viewTitle">
              <el-tooltip :content="(view as any).text" :disabled="(view as any).text.length < 11" :enterable="false"
                          placement="top">
                <span>
                  <svg-icon v-if="(view as any).Icon" :icon-class="(view as any).Icon"/>
                  <span>{{ (view as any).text }}</span>
                </span>
              </el-tooltip>
            </span>
            <div class="oper" @click.stop="">
              <span v-if="ShowCount" class="count">
                {{ (view as any).Count }}
              </span>
              <el-dropdown v-if="(view as any).value && (view as any).value.length === 32 && OperaMenu" trigger="click"
                           @command="MenuCommand($event, view)">
                <div class="menu-opt">
                  <svg-icon icon-class="more"/>
                </div>
                <template #dropdown>
                  <el-dropdown-menu>
                    <template v-for="item in OperaMenu" :key="item">
                      <el-dropdown-item v-if="(item as any).IsEstateBy !== (view as any).Estate"
                                        :command="(item as any).Value" :disabled="(item as any).disabled">
                        {{ (item as any).Title }}
                      </el-dropdown-item>
                    </template>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </el-menu-item>
        </el-menu>
      </el-scrollbar>
    </div>
    <slot v-if="!DelayShowSiderBar" name="ViewBarContent"/>
    <el-tooltip :hide-after="0" placement="top">
      <template #content>
        {{ showSiderBar ? "展开" : "收起" }}
      </template>
      <div class="layout-sider-bar-toggle" @click="ChangeSiderBar">
        <svg-icon icon-class="arrow-left"/>
      </div>
    </el-tooltip>
  </section>
</template>

<script lang="ts" setup>
import {computed, ref, watch} from "vue";
import {Framework} from "./proto/proto";
import {ElMessageBox} from "element-plus";
import power from "./power.vue"

const props = defineProps({
  /** 模块 */
  Module: String,
  /** 显示视图列 */
  ShowBar: Boolean,
  /** 是否需要限制左侧导航的宽度 */
  limitWidth: {type: Boolean, default: false},
  /** 自定义视图列 */
  MyViewBar: {type: Boolean, default: false},
  /** 视图列标题 */
  Title: String,
  /** 视图数据 */
  Datas: {type: Array, default: () => [] as any},
  /** 视图操作菜单 */
  OperaMenu: Array,
  /** 视图采用树 */
  IsTree: Boolean,
  /** 左视图树默认展开？ */
  DefaultExpandAll: Boolean,
  /** 左视图树默认选中节点 */
  DefaultArr: {type: Array, default: () => []},
  /** 左侧树形多选？ */
  ShowTreeCheckbox: Boolean,
  /** 显示视图节点的数量 */
  ShowCount: {type: Boolean, default: true},
  /** 显示视图标题 */
  ShowTitle: {type: Boolean, default: true},
  /** 创建视图描述 */
  CreateDesc: String,
  /** 显示创建视图按钮 */
  ShowCreateButton: {type: Boolean, default: true},
});

const showSiderBar = ref(false);
const DelayShowSiderBar = ref();
const ViewCurrent = computed(() => {
  if (props.DefaultArr && props.DefaultArr.length > 0) {
    return props.DefaultArr[0]!.toString();
  }
  return "";
});

/** 声明事件 */
const emit = defineEmits([
  "CreateHandle",
  "MenuCommand",
  "SelectedChanged",
]);

watch(
    () => showSiderBar.value,
    (val) => {
      setTimeout(() => {
        DelayShowSiderBar.value = val;
      }, 200);
    }
);

/** 视图菜单操作指令 */
const MenuCommand = (command: string, view: any) => {
  const findMenu = props.OperaMenu?.find((v: any) => v.Value === command) as any;

  if (findMenu && findMenu.IsDelete) {
    ElMessageBox.confirm("此操作将永久删除这些数据, 是否继续?", "", {
      confirmButtonText: "确认删除",
      cancelButtonText: "取消",
      type: "warning"
    })
        .then(() => {
          emit("MenuCommand", command, view);
        })
        .catch(() => {
        });

    return;
  }
  emit("MenuCommand", command, view);
};

/** 视图切换 */
const SelectedChanged = (key: any, data: any) => {
  // ViewCurrent.value = key;

  emit("SelectedChanged", key, data);
};
// 展开/收起左侧侧边栏事件
const ChangeSiderBar = () => {
  showSiderBar.value = !showSiderBar.value;
};
</script>

<!--<script lang="ts">-->
<!--import {getElementPlusTreeLine} from "element-plus-tree-line";-->
<!--import "element-plus-tree-line/dist/style.scss";-->
<!--import {h} from 'vue';-->

<!--export default {-->
<!--  components: {-->
<!--    ElementTreeLine: getElementPlusTreeLine(h)-->
<!--  }, data() {-->
<!--    return {};-->
<!--  },-->
<!--};-->
<!--</script>-->

<style lang="scss" scoped>

</style>